export enum OpeningHoursStatusType {
  CurrentlyClosed,
  AlwaysOpen,
  SeasonallyClosed,
}

export type OpeningHoursResponse = Record<string, OpeningHoursApiItemType>

export type OpeningHoursApiItemType =
  OpeningHoursStatusType | number[][] | undefined
